import type { components } from "@/__openapi__/backend/schema";

/**
 * Over-the-wire transcript turn stored on `CapturedAudio.transcript_array`.
 *
 * Anchored to the backend OpenAPI contract, with local extensions for fields
 * that the backend supports before this ignored generated file is refreshed.
 */
type BackendTranscriptArraySpeakerParticipant =
  components["schemas"]["CapturedAudioTranscriptSpeakerParticipant"];

export const TranscriptSpeakerAudioSource = {
  LocalMicrophone: "local_microphone",
  SystemAudio: "system_audio",
  Unknown: "unknown",
} as const;

export type TranscriptSpeakerAudioSource =
  (typeof TranscriptSpeakerAudioSource)[keyof typeof TranscriptSpeakerAudioSource];

export const TranscriptSpeakerVariant = {
  Unknown: "unknown",
  Self: "self",
  Other: "other",
} as const;

export type TranscriptSpeakerVariant =
  (typeof TranscriptSpeakerVariant)[keyof typeof TranscriptSpeakerVariant];

export const TranscriptSpeakerIdentificationContext = {
  Unknown: "unknown",
  WholeDesktop: "whole_desktop",
  MeetingWindow: "meeting_window",
} as const;

export type TranscriptSpeakerIdentificationContext =
  (typeof TranscriptSpeakerIdentificationContext)[keyof typeof TranscriptSpeakerIdentificationContext];

export const TranscriptSpeakerIdentificationReason = {
  Unknown: "unknown",
  LegacyChannel: "legacy_channel",
  WholeDesktopRecallHostLabel: "whole_desktop_recall_host_label",
  WholeDesktopRecallGuestLabel: "whole_desktop_recall_guest_label",
  WholeDesktopUnknown: "whole_desktop_unknown",
  MeetingWindowPlatformParticipant: "meeting_window_platform_participant",
  MeetingWindowUnknown: "meeting_window_unknown",
} as const;

export type TranscriptSpeakerIdentificationReason =
  (typeof TranscriptSpeakerIdentificationReason)[keyof typeof TranscriptSpeakerIdentificationReason];

export type TranscriptArraySpeakerParticipant = BackendTranscriptArraySpeakerParticipant & {
  is_platform_host?: boolean | null;
};

export type TranscriptSpeakerLabelKind =
  components["schemas"]["CapturedAudioTranscriptSpeakerLabelKind"];

export type TranscriptArrayItem = {
  [key: string]: unknown;
  sort_key: string;
  transcript: string;
  channel: number;
  disconnected?: boolean;
  timestamp?: string | null;
  speaker_participant?: TranscriptArraySpeakerParticipant | null;
  speaker_label?: number | string | null;
  speaker_label_kind?: TranscriptSpeakerLabelKind | null;
  speaker_id?: string | null;
  speaker_variant?: TranscriptSpeakerVariant | null;
  speaker_identification_context?: TranscriptSpeakerIdentificationContext | null;
  speaker_identification_reason?: TranscriptSpeakerIdentificationReason | null;
  speaker_audio_source?: TranscriptSpeakerAudioSource;
};

export type TranscriptSpeakerParticipantMetadata = {
  id?: number | string | null;
  name?: string | null;
  isPlatformHost?: boolean | null;
  /** Legacy frontend metadata from earlier builds. Prefer isPlatformHost. */
  isHost?: boolean | null;
  platform?: string | null;
  email?: string | null;
  extraData?: Record<string, unknown> | null;
};
